module.exports = "mutation ($id: ID!, $data: PostInput!) {\n  PostUpdate(id: $id, data: $data) {\n    id\n    url\n    previewUrl\n    isPublished\n  }\n}\n"